import KunLoading43 from './src/index'

KunLoading43.install = function (Vue) {
	Vue.component(KunLoading43.name, KunLoading43);
}

export default KunLoading43;
